import type { GetCopyArguments } from "../copy";

export interface ApiErrorResponse {
  code?: string;
  short_message: string;
  long_message: string;
  url?: string;
}
export async function handleApiError(
  response: Response,
): Promise<ApiErrorResponse> {
  try {
    const { code } = (await response.json()) as ApiErrorResponse;
    return Promise.reject({
      code,
    });
  } catch {
    // API error with no Kivra code
    return Promise.reject({
      code: response.status.toString(),
    });
  }
}

const apiErrorMap: Record<string, GetCopyArguments> = {
  "40000": ["api_error_msg__core_40000"],
  "40001": ["api_error_msg__core_40001"],
  "40005": ["api_error_msg__core_40005"],
  "40006": ["api_error_msg__core_40006"],
  "40007": ["api_error_msg__core_40007"],
  "40009": ["api_error_msg__core_40009"],
  "40025": ["api_error_msg__core_40025"],
  "40101": ["api_error_msg__core_40101"],
  "40103": ["api_error_msg__core_40103"],
  "40104": ["api_error_msg__core_40104"],
  "40106": ["api_error_msg__core_40106"],
  "40107": ["api_error_msg__core_40107"],
  "40111": ["api_error_msg__core_40111"],
  "40400": ["api_error_msg__core_40400"],
  "42203": ["api_error_msg__core_42203"],
  "42900": ["api_error_msg__core_42900"],
  "50000": ["api_error_msg__core_50000"],
};

export function mapErrorCodeToCopyKey(
  errorCode?: string,
): GetCopyArguments {
  const defaultApiErrorCode = "50000";
  const code = errorCode || defaultApiErrorCode;
  return apiErrorMap[code] || apiErrorMap[defaultApiErrorCode]!;
}
